import {css} from "@emotion/react";
import React from 'react';
import {cssArray, CSSType} from "../../utils";
import {grid} from "./styles";

export interface GridProps {
    inverted?: boolean;
    lsize?: string;
    rsize?: string;
    contentCss?: CSSType;
}


export const Grid: React.FC<GridProps> = ({
    contentCss: _css,
    children,
    inverted,
    lsize = "0.6fr",
    rsize = "0.4fr",
}) => {
    const strSize = [lsize, rsize];
    return (
        <div css={[grid, css({
            gridTemplateColumns: (inverted ? strSize.reverse() : strSize).join(' ')
        }), ...cssArray(_css)]}>
            {children}
        </div>
    );
};